import store from '../store';
import { ipfsDecode, ipfsEncode } from './web3Actions'

export function refreshPosts() {
  return function(dispatch) {

    const { ipfsInstance, theWallInstance, ethAccount } = store.getState().web3;

    theWallInstance.getNumPosts.call({from: ethAccount}).then((numPosts) => {

      let promiseArr = [];
      if(numPosts > 0) {
        for(let i=numPosts-1; i>=0; i--) {
          promiseArr.push(theWallInstance.getPost.call(i,{from: ethAccount}));
        }
      }

      Promise.all(promiseArr).then(function(values) {

        let hashList = [];
        let ipfsPromiseArr = [];
        for(let i=0; i<values.length; i++) {
          hashList.push(ipfsEncode(values[i]));
        }

        dispatch({
          type: "REPLACE_KEY_LIST",
          payload: hashList
        });

        for(let i=0; i<hashList.length; i++) {
          let resultHash = hashList[i];

          ipfsPromiseArr.push(new Promise((resolve, reject) => {
            ipfsInstance.cat(resultHash, (err, data) => {

              if (err) {
                resolve({success:false, text:"", hash:resultHash});    
                //reject();
              }
              resolve({success:true, text:data, hash:resultHash});    
            });
          }).then(results => {

            if(results.success) {
              dispatch({
                type: "ADD_POST_MAP_ENTRY",
                payload: { key: results.hash, text: results.text }
              });
            }

            return results; 
          }));
        }

        Promise.all(ipfsPromiseArr).then(function(ipfsValues) {
        });
      });
    })
  }
}

export function newPost(text) {
  return function(dispatch) {

    const { ipfsInstance, theWallInstance, ethAccount } = store.getState().web3;

    ipfsInstance.add(text, (err, result) => {
      let hash = result;
      let decodedHash = ipfsDecode(result);

      //theWallInstance.submitPost(decodedHash, text, {from: ethAccount, value: 100000000000000000}).then((result) => {
      theWallInstance.submitPost.sendTransaction(decodedHash, text, {from: ethAccount, value: 100000000000000000}).then((result) => {

        dispatch({
          type: 'NEW_POST_FULFILLED',
          payload: {
              key: hash, 
              text: text
            }
        });

      }).catch(() => {
      });
    });    
  }
}

export function updatePostInputText(text) {
  return {
    type: 'UPDATE_POST_INPUT',
    payload: text
  }
}

export function listenToEvents(text) {
  return function(dispatch) {

    const { theWallInstance } = store.getState().web3;
    
    /*
    theWallInstance.allEvents({
      fromBlock: 0,
      toBlock: 'latest'
    }, (err, event) => {
      if(event && event.event === "EventWallPost" && event.args && "_hashOfPost" in event.args && "_textOfPost" in event.args) {
        dispatch({
          type: "ADD_POST_MAP_ENTRY",
          payload: { key: ipfsEncode(event.args._hashOfPost), text: event.args._textOfPost }
        });
      }
    });
    */

    let eventWallPost = theWallInstance.EventWallPost({},{
      fromBlock: 0,
      toBlock: 'latest'
    });

    eventWallPost.watch((error, event) => {
      if(event && event.event === "EventWallPost" && event.args && "_hashOfPost" in event.args && "_textOfPost" in event.args) {
        dispatch({
          type: "ADD_POST_MAP_ENTRY",
          payload: { key: ipfsEncode(event.args._hashOfPost), text: event.args._textOfPost }
        });
      }
    });


  }
}


// WEBPACK FOOTER //
// ./src/actions/wallActions.js